import * as React from 'react';
import { useState, useEffect } from 'react';
import FrameOverlay from '../../../frameOverlay';
// import '../../../Faceplate.css';
import SingleWindowTab from './components/Tabs/SingleWindowTab';
import FaceplateManager from 'components/FaceplateManager';
import { IFaceplate } from 'components/FaceplateManager';

function SingleWindow(props: IFaceplate) {
    const [height, setHeight] = useState(100);
    const [width, setWidth] = useState(200);

    const [tempheight, setTempHeight] = useState(100);
    const [tempwidth, setTempWidth] = useState(200);

    const [top, setTop] = useState(props.Top);
    const [left, setLeft] = useState(props.Left);
    const [typeMove, setTypeMove] = useState(-1);
    const [TempX, setTempX] = useState(0);
    const [TempY, setTempY] = useState(0);
    const [MinWin, setMinWin] = useState({ h: 100, w: 100 });
    const [MaxWin, setMaxWin] = useState({ h: 1080, w: 1920 });
    const [title, setTitle] = useState('');

    const [inFrameOverlay, setinFrameOverlay] = useState(false);

    const previousheightRef = React.useRef<number>();
    const previousheight = previousheightRef.current;
    if (props.Height !== previousheight && props.Height !== height) {
        setHeight(props.Height);
        setTempHeight(props.Height);
    }

    const previouswidthRef = React.useRef<number>();
    const previouswidth = previouswidthRef.current;
    if (props.Width !== previouswidth && props.Width !== width) {
        setWidth(props.Width);
        setTempWidth(props.Width);
    }

    const previoustitleRef = React.useRef<string>();
    const previoustitle = previoustitleRef.current;
    if (props.title !== previoustitle && props.title !== title) {
        setTitle(props.title);
    }

    useEffect(() => {
        previouswidthRef.current = props.Width;
        previousheightRef.current = props.Height;
        previoustitleRef.current = props.title;
    });

    const OnMove = (event: MouseEvent) => {
        //  console.debug("Move:X=" + event.pageX + " Y=" + event.pageY + " typeMove=" + typeMove);
        if (typeMove > -1) {
            //console.debug("Move:X=" + event.pageX + " Y=" + event.pageY);
            switch (typeMove) {
                case 0: {
                    let X = event.pageX - TempX;
                    let Y = event.pageY - TempY;

                    let NewTop = top + Y;
                    let NewLeft = left + X;

                    let LeftMax = document.documentElement.clientWidth - width;
                    NewLeft = NewLeft < 0 ? 0 : NewLeft > LeftMax ? LeftMax : NewLeft;

                    let TopMax = document.documentElement.clientHeight - height;
                    NewTop = NewTop < 0 ? 0 : NewTop > TopMax ? TopMax : NewTop;

                    setLeft(NewLeft);
                    setTop(NewTop);
                    setTempX(event.pageX);
                    setTempY(event.pageY);
                    //this.setState({ top: NewTop, left: NewLeft, TempX: event.pageX, TempY: event.pageY });
                    break;
                }
                case 1: {
                    let Y = event.pageY - TempY;

                    let NewTop = top + Y;
                    let NewHeight = height - Y;

                    if (NewHeight > MaxWin.h) NewHeight = MaxWin.h;
                    if (NewHeight < MinWin.h) NewHeight = MinWin.h;

                    let TopMax = document.documentElement.clientHeight - height;
                    NewTop = NewTop < 0 ? 0 : NewTop > TopMax ? TopMax : NewTop;

                    setTop(NewTop);
                    setHeight(NewHeight);
                    setTempX(event.pageX);
                    setTempY(event.pageY);
                    //this.setState({ top: NewTop, height: NewHeight, TempX: event.pageX, TempY: event.pageY });
                    break;
                }
                case 2: {
                    let Y = event.pageY - TempY;
                    let X = event.pageX - TempX;

                    let NewTop = top + Y;
                    let NewHeight = height - Y;
                    let NewWidth = width + X;

                    if (NewHeight > MaxWin.h) NewHeight = MaxWin.h;
                    if (NewHeight < MinWin.h) NewHeight = MinWin.h;

                    if (NewWidth > MaxWin.w) NewWidth = MaxWin.w;
                    if (NewWidth < MinWin.w) NewWidth = MinWin.w;

                    let TopMax = document.documentElement.clientHeight - height;
                    NewTop = NewTop < 0 ? 0 : NewTop > TopMax ? TopMax : NewTop;

                    setWidth(NewWidth);
                    setTop(NewTop);
                    setHeight(NewHeight);
                    setTempX(event.pageX);
                    setTempY(event.pageY);
                    //this.setState({ top: NewTop, height: NewHeight, width: NewWidth, TempX: event.pageX, TempY: event.pageY });
                    break;
                }
                case 3: {
                    let X = event.pageX - TempX;

                    let NewWidth = width + X;

                    if (NewWidth > MaxWin.w) NewWidth = MaxWin.w;
                    if (NewWidth < MinWin.w) NewWidth = MinWin.w;

                    setWidth(NewWidth);
                    setTempX(event.pageX);
                    setTempY(event.pageY);
                    //this.setState({ width: NewWidth, TempX: event.pageX, TempY: event.pageY });
                    break;
                }
                case 4: {
                    let X = event.pageX - TempX;
                    let Y = event.pageY - TempY;

                    let NewWidth = width + X;
                    let NewHeight = height + Y;

                    if (NewHeight > MaxWin.h) NewHeight = MaxWin.h;
                    if (NewHeight < MinWin.h) NewHeight = MinWin.h;

                    if (NewWidth > MaxWin.w) NewWidth = MaxWin.w;
                    if (NewWidth < MinWin.w) NewWidth = MinWin.w;

                    setWidth(NewWidth);
                    setHeight(NewHeight);
                    setTempX(event.pageX);
                    setTempY(event.pageY);
                    //this.setState({ height: NewHeight, width: NewWidth, TempX: event.pageX, TempY: event.pageY });
                    break;
                }
                case 5: {
                    let Y = event.pageY - TempY;

                    let NewHeight = height + Y;

                    if (NewHeight > MaxWin.h) NewHeight = MaxWin.h;
                    if (NewHeight < MinWin.h) NewHeight = MinWin.h;

                    setHeight(NewHeight);
                    setTempX(event.pageX);
                    setTempY(event.pageY);
                    //this.setState({ height: NewHeight, TempX: event.pageX, TempY: event.pageY });
                    break;
                }
                case 6: {
                    let X = event.pageX - TempX;
                    let Y = event.pageY - TempY;

                    let NewLeft = left + X;
                    let NewWidth = width - X;
                    let NewHeight = height + Y;

                    if (NewHeight > MaxWin.h) NewHeight = MaxWin.h;
                    if (NewHeight < MinWin.h) NewHeight = MinWin.h;

                    if (NewWidth > MaxWin.w) NewWidth = MaxWin.w;
                    if (NewWidth < MinWin.w) NewWidth = MinWin.w;

                    let LeftMax = document.documentElement.clientWidth - width;
                    NewLeft = NewLeft < 0 ? 0 : NewLeft > LeftMax ? LeftMax : NewLeft;

                    setLeft(NewLeft);
                    setWidth(NewWidth);
                    setHeight(NewHeight);
                    setTempX(event.pageX);
                    setTempY(event.pageY);
                    //this.setState({ left: NewLeft, width: NewWidth, height: NewHeight, TempX: event.pageX, TempY: event.pageY });
                    break;
                }
                case 7: {
                    let X = event.pageX - TempX;

                    let NewLeft = left + X;
                    let NewWidth = width - X;

                    if (NewWidth > MaxWin.w) NewWidth = MaxWin.w;
                    if (NewWidth < MinWin.w) NewWidth = MinWin.w;

                    let LeftMax = document.documentElement.clientWidth - width;
                    NewLeft = NewLeft < 0 ? 0 : NewLeft > LeftMax ? LeftMax : NewLeft;

                    setLeft(NewLeft);
                    setWidth(NewWidth);
                    setTempX(event.pageX);
                    setTempY(event.pageY);
                    //this.setState({ left: NewLeft, width: NewWidth, TempX: event.pageX, TempY: event.pageY });
                    break;
                }
                case 8: {
                    let X = event.pageX - TempX;
                    let Y = event.pageY - TempY;

                    let NewTop = top + Y;
                    let NewHeight = height - Y;
                    let NewLeft = left + X;
                    let NewWidth = width - X;

                    if (NewHeight > MaxWin.h) NewHeight = MaxWin.h;
                    if (NewHeight < MinWin.h) NewHeight = MinWin.h;

                    if (NewWidth > MaxWin.w) NewWidth = MaxWin.w;
                    if (NewWidth < MinWin.w) NewWidth = MinWin.w;

                    let LeftMax = document.documentElement.clientWidth - width;
                    NewLeft = NewLeft < 0 ? 0 : NewLeft > LeftMax ? LeftMax : NewLeft;

                    let TopMax = document.documentElement.clientHeight - height;
                    NewTop = NewTop < 0 ? 0 : NewTop > TopMax ? TopMax : NewTop;

                    setLeft(NewLeft);
                    setWidth(NewWidth);
                    setTop(NewTop);
                    setHeight(NewHeight);
                    setTempX(event.pageX);
                    setTempY(event.pageY);
                    //this.setState({ left: NewLeft, width: NewWidth, top: NewTop, height: NewHeight, TempX: event.pageX, TempY: event.pageY });
                    break;
                }
            }
        }
    };

    const OnDownMouse = (type: number, X: number, Y: number) => {
        // console.debug("OnDownMouse " + X + ":" + Y + " ;" + type);
        setinFrameOverlay(true);

        setTypeMove(type);
        setTempX(X);
        setTempY(Y);

        const Faceplates = document.getElementsByClassName('FaceplateMainDiv');
        for (let i = 0; i < Faceplates.length; i++) {
            const slide = Faceplates[i] as HTMLElement;
            slide.style.zIndex = '45';
            slide.classList.remove('action');
        }
        const ActionFaceplates = document.getElementById(props.indexFaceplate + 'MainDiv');
        if (ActionFaceplates != null) {
            ActionFaceplates.style.zIndex = '50';
            ActionFaceplates.classList.add('action');
        }
    };

    const OnUpMouse = (event: MouseEvent) => {
        setinFrameOverlay(false);

        //console.debug("OnUpMouse");
        setTypeMove(-1);
    };

    // const OnTabClick = (id: number) => {
    //     if(props.SetActiveTab) props.SetActiveTab(id)
    // };

    //Сохранение положения фейсплейта
    useEffect(() => {
        if (props.onPositionChange) {
            props.onPositionChange(left, top, props.indexFaceplate);
        }
    }, [typeMove]);

    useEffect(() => {
        let NewLeft = props.Left;
        let LeftMax = document.documentElement.clientWidth - width;
        NewLeft = NewLeft < 0 ? 0 : NewLeft > LeftMax ? LeftMax : NewLeft;

        let NewTop = props.Top;

        let TopMax = document.documentElement.clientHeight - height;
        NewTop = NewTop < 0 ? 0 : NewTop > TopMax ? TopMax : NewTop;

        setLeft(NewLeft);
        setTop(NewTop);
    }, [props.Top, props.Left, props.Width, props.Height]);

    useEffect(() => {
        if (props.CallbackRender != undefined) props.CallbackRender(props.indexFaceplate);
    }, []);

    useEffect(() => {
        document.addEventListener('mousemove', OnMove);
        document.addEventListener('mouseup', OnUpMouse);

        return () => {
            document.removeEventListener('mousemove', OnMove);
            document.removeEventListener('mouseup', OnUpMouse);
        };
    }, [typeMove]);

    const FullWindow = (height: number, width: number) => {
        if (height !== props.Height && width !== props.Width) {
            // Полный экран
            setTempHeight(height);
            setTempWidth(width);
            setHeight(props.Height);
            setWidth(props.Width);
        } else if (height == props.Height && width == props.Width) {
            // Вернуться к предыдущему
            setHeight(tempheight);
            setWidth(tempwidth);
        }
    };

    const { OnCollapse } = props;
    const toggleCollapse = () => {
        if (OnCollapse) {
            OnCollapse(props.indexFaceplate, height, width);
        }
    };

    //Закрытие окна SpecialWin при нажатии вне окна
    useEffect(() => {
        const handleDocumentClick = (event: any) => {
            const specialWinTab = document.querySelector('.FaceplateSpecialWin');

            if (specialWinTab && !specialWinTab.contains(event.target)) {
                if (props.OnClose !== undefined && props.size.toUpperCase() === 'SPECIALWIN') {
                    props.OnClose();
                }
            }
        };

        const iframes = document.querySelectorAll('iframe');

        iframes.forEach((iframe) => {
            const isInsideSpecialWin = iframe.closest('.FaceplateSpecialWin');

            if (!isInsideSpecialWin) {
                iframe.contentDocument?.addEventListener('mousedown', handleDocumentClick);
            }
        });

        document.addEventListener('mousedown', handleDocumentClick);

        return () => {
            iframes.forEach((iframe) => {
                iframe.contentDocument?.removeEventListener('mousedown', handleDocumentClick);
            });

            document.removeEventListener('mousedown', handleDocumentClick);
        };
    }, []);

    let tabToRender;

    switch (props.size.toUpperCase()) {
        case 'SPECIALWIN':
            tabToRender = (
                <React.Fragment>
                    {/* <div className='hideWindow' style={{position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'transparent', zIndex: 0}}></div> */}

                    <div
                        className="FaceplateSpecialWin"
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            height: '100%',
                            width: '100%',
                            flexGrow: 1,
                            backgroundColor: '#d4d0c8'
                        }}>
                        <div style={{ height: '100%', width: '100%', flexGrow: 1 }}>
                            <div className="special-win__tab">
                                <div
                                    className="special-win__title"
                                    title={title}
                                    onMouseDown={(event: any) => {
                                        OnDownMouse(0, event.pageX, event.pageY);
                                    }}
                                    onClick={(event: any) => {}}>
                                    {title}
                                </div>
                                <div
                                    className="special-win__close-btn"
                                    onClick={() => {
                                        if (props.OnClose != undefined) props.OnClose();
                                    }}>
                                    <svg
                                        width="8"
                                        height="8"
                                        viewBox="0 0 10 10"
                                        xmlns="http://www.w3.org/2000/svg"
                                        style={{ position: 'relative', top: '-10px' }}>
                                        <path d="M5.00068 4.03501L1.16155 0.190728C1.03354 0.0669619 0.862078 -0.00152229 0.684106 2.56818e-05C0.506135 0.00157365 0.335891 0.0730297 0.210042 0.199004C0.084192 0.324978 0.0128065 0.495391 0.0112601 0.673538C0.00971363 0.851685 0.0781295 1.02331 0.201773 1.15146L4.03954 4.99574L0.199058 8.83866C0.0716033 8.96624 2.23759e-09 9.13927 0 9.3197C-2.23759e-09 9.50013 0.0716033 9.67316 0.199058 9.80075C0.326513 9.92833 0.499379 10 0.679628 10C0.859876 10 1.03274 9.92833 1.1602 9.80075L5.00068 5.95647L8.8398 9.80075C8.90291 9.86392 8.97783 9.91403 9.06029 9.94822C9.14275 9.9824 9.23112 10 9.32037 10C9.40962 10 9.498 9.9824 9.58046 9.94822C9.66291 9.91403 9.73783 9.86392 9.80094 9.80075C9.86405 9.73757 9.91411 9.66258 9.94827 9.58004C9.98242 9.4975 10 9.40904 10 9.3197C10 9.23036 9.98242 9.1419 9.94827 9.05936C9.91411 8.97682 9.86405 8.90183 9.80094 8.83866L5.96046 4.99574L9.80094 1.15282C9.92459 1.02467 9.993 0.853044 9.99146 0.674897C9.98991 0.496749 9.91852 0.326337 9.79267 0.200363C9.66682 0.0743885 9.49658 0.00293243 9.31861 0.00138447C9.14064 -0.000163502 8.96918 0.0683207 8.84116 0.192087L5.00068 4.03365V4.03501Z" />
                                    </svg>
                                </div>
                            </div>
                            <div style={{ background: '#fff', height: 'calc(100% - 20px)', width: '100%' }}>
                                <iframe
                                    style={{ background: '#fff', height: '100%', width: '100%' }}
                                    id={props.indexFaceplate}
                                    name="faceplateframe"
                                    className="faceplateframe"></iframe>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            );
            break;
        default:
            tabToRender = (
                <>
                    <div style={{ display: 'flex', flexDirection: 'row', height: '2px', width: '100%', flexGrow: 0 }}>
                        <div
                            className="corner"
                            style={{
                                cursor: 'nw-resize',
                                width: '20px',
                                height: '20px',
                                borderBottomRightRadius: '14px',
                                backgroundColor: 'transparent'
                            }}
                            onMouseDown={(event: any) => {
                                OnDownMouse(8, event.pageX, event.pageY);
                            }}></div>
                        <div
                            className="BorderSandN"
                            style={{ cursor: 's-resize', backgroundColor: 'transparent' }}
                            onMouseDown={(event: any) => {
                                OnDownMouse(1, event.pageX, event.pageY);
                            }}></div>
                        <div
                            className="corner"
                            style={{
                                cursor: 'ne-resize',
                                width: '20px',
                                height: '20px',
                                borderBottomRightRadius: '14px',
                                backgroundColor: 'transparent'
                            }}
                            onMouseDown={(event: any) => {
                                OnDownMouse(2, event.pageX, event.pageY);
                            }}></div>
                    </div>

                    <div
                        className={`single-window__tab ${props.active ? 'active' : ''}`}
                        title={props.title != '' ? props.title : props.indexFaceplate}
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            alignItems: 'flex-end'
                        }}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            id="svg_content"
                            x="700"
                            y="510.25"
                            viewBox={`0 0 ${width} 15`}
                            transform="matrix(1,0,0,1,0,0)"
                            preserveAspectRatio="none"
                            style={{
                                cursor: 'default',
                                width: '100%',
                                height: '25px',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            }}
                            onMouseDown={(event: any) => {
                                OnDownMouse(0, event.pageX, event.pageY);
                                if (props.SelectActiveTab) props.SelectActiveTab(props.id);
                            }}>
                            <g transform="matrix(1,0,0,1,0,0)" id="left">
                                <g className="rect-group">
                                    <rect
                                        transform="matrix(1,0,0,1,0,5)"
                                        fill="#fff"
                                        id="rect1"
                                        className="rect"
                                        width={width + 'px'}
                                        height="10"
                                    />
                                    <rect
                                        transform="matrix(1,0,0,1,0,0)"
                                        id="rect2"
                                        className="rect"
                                        width={width + 'px'}
                                        height="10"
                                        rx="10"
                                        ry="10"
                                        preserveAspectRatio="none"
                                    />
                                </g>
                            </g>
                        </svg>
                        <svg xmlns="http://www.w3.org/2000/svg" id="svg_text" preserveAspectRatio="none">
                            <linearGradient id="circleGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                                <stop offset="0%" style={{ stopColor: '#eaf4dd' }} />
                                <stop offset="100%" style={{ stopColor: '#cae385' }} />
                            </linearGradient>
                            <circle cx="16" cy="13" r="7" fill="url(#circleGradient)" stroke="#28488a" />
                            <text x="30" y="18" fill="black">
                                {props.title != '' ? props.title : props.indexFaceplate}
                            </text>
                        </svg>
                        <svg xmlns="http://www.w3.org/2000/svg" className="Buttons">
                            <g className="collapse" onClick={toggleCollapse} transform="translate(-20, 0)">
                                <rect x="24" y="4" width="18" height="18"></rect>
                                <line
                                    className="collapse"
                                    x1="27"
                                    y1="17"
                                    x2="39"
                                    y2="17"
                                    fill="none"
                                    stroke="white"
                                    strokeWidth="2"
                                />
                            </g>
                            <g
                                className="fullWindow"
                                onClick={() => {
                                    FullWindow(height, width);
                                }}
                                transform="translate(-18, 0)">
                                <rect x="42" y="4" width="18" height="18"></rect>
                                <rect x="46" y="8" width="10" height="10" fill="none" stroke="white" strokeWidth="2" />
                            </g>
                            <g
                                className="closeButton"
                                transform="matrix(1,0,0,1,-136,7)"
                                id="right"
                                onClick={() => {
                                    if (props.OnClose != undefined) props.OnClose();
                                }}>
                                <rect className="closeButtonRect" x="180" y="-3" width="18" height="18" />
                                <line id="line2" transform="matrix(1,0,0,1,195,0)" x2="-12" y2="12" stroke="white" />
                                <line id="line3" transform="matrix(1,0,0,1,183,0)" x2="12" y2="12" stroke="white" />
                            </g>
                        </svg>
                        <div
                            className="cornerLeft"
                            onMouseDown={(event: any) => {
                                OnDownMouse(8, event.pageX, event.pageY);
                            }}></div>
                        <div
                            className="cornerRight"
                            onMouseDown={(event: any) => {
                                OnDownMouse(2, event.pageX, event.pageY);
                            }}></div>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            height: 'calc(100% - 23px)',
                            width: '100%',
                            flexGrow: 1
                        }}>
                        <div
                            className="BorderWandE"
                            style={{ cursor: 'e-resize' }}
                            onMouseDown={(event: any) => {
                                OnDownMouse(7, event.pageX, event.pageY);
                            }}></div>
                        {/* <div style={{ background: '#fff', height: '100%', width: '100%' }}> */}
                        <iframe
                            style={{ background: '#fff', height: '100%', width: 'calc(100% - 2px)' }}
                            id={props.indexFaceplate}
                            name="faceplateframe"
                            className="faceplateframe"></iframe>
                        {/* </div> */}
                        <div
                            className="BorderWandE"
                            style={{ cursor: 'w-resize' }}
                            onMouseDown={(event: any) => {
                                OnDownMouse(3, event.pageX, event.pageY);
                            }}></div>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'row', height: '2px', width: '100%', flexGrow: 0 }}>
                        <div
                            className="corner"
                            style={{ cursor: 'ne-resize' }}
                            onMouseDown={(event: any) => {
                                OnDownMouse(6, event.pageX, event.pageY);
                            }}></div>
                        <div
                            className="BorderSandN"
                            style={{ cursor: 'n-resize' }}
                            onMouseDown={(event: any) => {
                                OnDownMouse(5, event.pageX, event.pageY);
                            }}></div>
                        <div
                            className="corner"
                            style={{ cursor: 'nw-resize' }}
                            onMouseDown={(event: any) => {
                                OnDownMouse(4, event.pageX, event.pageY);
                            }}></div>
                    </div>
                </>
            );
    }

    return (
        <div>
            <FrameOverlay visibility={inFrameOverlay} />

            <div
                style={{
                    boxShadow: '0px 17px 14px rgba(0, 0, 0, 0.08)',
                    display: 'flex',
                    flexDirection: 'column',
                    position: 'absolute',
                    zIndex: 50,
                    background: 'transparent',
                    height: height + 'px',
                    width: width + 'px',
                    top: top + 'px',
                    left: left + 'px'
                }}
                className="FaceplateMainDiv"
                id={props.indexFaceplate + 'MainDiv'}>
                {tabToRender}
            </div>
        </div>
    );
}

export default SingleWindow;
